import { z } from 'zod';

import { logError } from '~/common/utils/log';
import type { ContractReport } from '~/services/wallet/withdrawal-eligibility.schema';

const ContestMessageAllowanceBucketSchema = z.object({
  audiences: z.array(z.string()),
  limit: z.number().int().nonnegative(),
  remaining: z.number().int().nonnegative(),
});

export const ContestMessageAllowanceSchema = z.object({
  resetsAt: z.string().datetime(),
  channel: z.object({
    limit: z.number().int().nonnegative(),
    remaining: z.number().int().nonnegative(),
  }),
  buckets: z.array(ContestMessageAllowanceBucketSchema),
});

const ContestMessageAllowanceResponseSchema = z.object({
  data: ContestMessageAllowanceSchema,
});

export type ContestMessageAllowance = z.infer<typeof ContestMessageAllowanceSchema>;

export const parseContestMessageAllowance = (
  raw: unknown,
  report: ContractReport = logError
): ContestMessageAllowance | null => {
  const result = ContestMessageAllowanceResponseSchema.safeParse(raw);

  if (result.success === false) {
    report('Unexpected contest-message-allowance response shape', {
      issues: result.error.issues.map((issue) => issue.path.join('.')),
    });
    return null;
  }

  return result.data.data;
};
